import React from 'react';

const Footer = () => {
  return (
    <footer className="border-t border-gray-200 bg-white dark:border-gray-800 dark:bg-black sticky bottom-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-5">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-0 text-center text-gray-500 dark:text-gray-400 text-xs sm:text-sm">
          <span>© 2026 Therefore Design Pvt. Ltd.</span>
          <span className="hidden sm:inline mx-2">|</span>
          <span>Brand Personality Quiz. Powered by Carl Jung's Archetypes</span>
          <span className="hidden sm:inline mx-2">|</span>
          <a href="mailto:info@thereforedesign.co.in" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            info@thereforedesign.co.in
          </a>
          <span className="hidden sm:inline mx-2">|</span>
          <a href="https://www.thereforedesign.co.in" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            www.thereforedesign.co.in
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
